import React, { useState, useEffect, useContext } from 'react';
import Menu from '../../components/sturtural/Menu';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { Chart } from 'primereact/chart';
import Loader from '../../components/sturtural/Loader';
import DashboardCheck from './DashboardCheck';
import { PanelMenu } from 'primereact/panelmenu';
import DashboardTable from './DashboardTable';
import { useNavigate } from 'react-router-dom';
import { storage } from '../../helpers/storage';

const Dashboard = () => {
    const navigate = useNavigate();

    const [pieOptions, setPieOptions] = useState(null);
    const [lineOptions, setLineOptions] = useState(null);
    const [barOptions, setBarOptions] = useState(null)

    const [general, setGeneral] = useState(null);
    const [loading, setLoading] = useState(false);

    const [piePreescolar, setPiePreescolar] = useState(null);
    const [piePrimaria, setPiePrimaria] = useState(null);
    const [pieSecundaria, setPieSecundaria] = useState(null);
    const [barData, setBarData] = useState(null);
    const [barDataGeneral, setBarDataGeneral] = useState(null);

    const [show, setShow] = useState(false);

    const [porcentajeNivel, setPorcentajeNivel] = useState(null);

    let perfil = storage.get('perfilid');
    let ciclo = storage.get('ciclo');


    useEffect(() => {
        if (![1, 3, 4, 5, 19, 20, 21].includes(perfil)) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        setLoading(true);
        if (ciclo !== null) {
            obtenerGraficas(ciclo)
        }
        // else {
        //     getInicioCiclo().then(x => {
        //         obtenerGraficas(x)
        //     })
        // }
    }, []);
    console.log('porcentajeNivel', porcentajeNivel);

    const obtenerGraficas = (ciclo) => {
    let url = `${BASE_API}Entrega/postGpxObtenerGraficas`;
        helpHttp().post(url, {
            body: {
                "lstIdMunicipios": [],
                "lstDelRegID": [],
                "lstIdEscuelas": [],
                "fechaInicio": ciclo.FechaIni,
                "fechaFin": ciclo.FechaFin,
                "IdCicloEscolar": ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {

                let gpxBarras = res.gpxBarras;
                setGeneralData(res);
                getPieData(res.gpxPastel);
                setBarraData(res.gpxBarras);

 
                if (gpxBarras.length > 0) {
                    setShow(true);
                }

                setBarraDataGeneral(res.gpxBarras);


            } else {
                //setDb(null);
                //setError(true);
            }
            setLoading(false);
        });
    }
    const setGeneralData = (res) => {
        const numberFormat = new Intl.NumberFormat("en-US");

        let totalEntrega = res.totalEntrega;
        let totalEntregado = res.totalEntregado;

        let cienporciento = 100;
        let porcentaje =  totalEntrega > 0 ? ((totalEntregado * cienporciento) / totalEntrega) : 0 ;

        const data = {
            totalEntrega: numberFormat.format(totalEntrega),
            totalEntregado: numberFormat.format(totalEntregado),
            totalPorEntregar: numberFormat.format((totalEntrega - totalEntregado)),
            porcentaje: ((porcentaje * 100) / 100).toString().substring(0,4),
        }
        setGeneral(data);
    }

    // const getInicioCiclo = async () => {
    //     const res = await helpHttp().post(`${BASE_API}Usuarios/SpdRptCicloEscolar`, {
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //             "Accept": "application/json",
    //             'Authorization': `Bearer ${storage.get('token')}`
    //         }
    //     }).then(res => res.ITEMS.find(x => x.Activo === true))

    //     return res;
    // }

    const getPieData = (gpxPastel) => {
        setPiePreescolar(setPieData(gpxPastel[0].Total, gpxPastel[1].Total));
        setPiePrimaria(setPieData(gpxPastel[2].Total, gpxPastel[3].Total));
        setPieSecundaria(setPieData(gpxPastel[4].Total, gpxPastel[5].Total));
    }

    const setPieData = (pendiente, entregado) => {
        const numberFormat = new Intl.NumberFormat("en-US");

        const pieData = {
            total: numberFormat.format(pendiente + entregado),
            labels: ['Entregado', 'Por entregar'],
            datasets: [
                {
                    data: [entregado, pendiente],
                    backgroundColor: [
                        "#dc7f37",
                        "#9b2f3e"
                    ],
                    hoverBackgroundColor: [
                        "#dc7f37",
                        "#9b2f3e"
                    ]
                }
            ]
        };

        return pieData;
    }

    const setBarraData = (gpxBarras) => {
        gpxBarras.sort((a, b) => new Date(a.FechaCreacion) - new Date(b.FechaCreacion));
        let fechas = gpxBarras.map((item) => { return item.FechaCreacion });
        let uniqueFechas = [...new Set(fechas)];

        //console.log(uniqueFechas);

        let dataPreescolar = gpxBarras.filter(item => item.Nivel === "Preescolar").map((item) => { return item.Total });
        let dataPrimaria = gpxBarras.filter(item => item.Nivel === "Primaria").map((item) => { return item.Total });
        let dataSecundaria = gpxBarras.filter(item => item.Nivel === "Secundaria").map((item) => { return item.Total });

        setBarData({
            labels: uniqueFechas,
            datasets: [
                {
                    label: 'PREESCOLAR',
                    backgroundColor: '#FF6384',
                    data: dataPreescolar
                },
                {
                    label: 'PRIMARIA',
                    backgroundColor: '#9b2f3e',
                    data: dataPrimaria
                },
                {
                    label: 'SECUNDARIA',
                    backgroundColor: '#FFCE56',
                    data: dataSecundaria
                }
            ]
        });
    }

    const setBarraDataGeneral = (gpxBarras) => {
        gpxBarras.sort((a, b) => new Date(a.FechaCreacion) - new Date(b.FechaCreacion));
        let fechas = gpxBarras.map((item) => { return item.FechaCreacion });
        let uniqueFechas = [...new Set(fechas)];
        let arrGerneral = [];

        //console.log(uniqueFechas);

        uniqueFechas.map(fecha => {
            arrGerneral.push(gpxBarras
                .filter(item => item.FechaCreacion === fecha)
                .reduce((accumulator, item) => { return accumulator + item.Total }, null));
        });

        setBarDataGeneral({
            labels: uniqueFechas,
            datasets: [
                {
                    label: 'ENTREGAS',
                    backgroundColor: '#9b2f3e',
                    data: arrGerneral
                }
            ]
        });
    }

    let url2 = `${BASE_API}demand/dashboard/municipios`;
    useEffect(() => {
        /*helpHttp().get(url2, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*'
            }
        }).then(res => {
            if(!res.err) {
                setTabla(res.demand);
                setErrorT(false);
            } else {
                setTabla(null);
                setErrorT(true);
            }
            setLoadingT(false);
        });*/
    }, [url2]);

    const applyLightTheme = () => {
        const pieOptions = {
            maintainAspectRatio: false,
            responsive: false,
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        color: '#17202A'
                    }
                }
            },
            cutout: '70%'
        };

        const barOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#2E4053'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#000'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
                y: {
                    ticks: {
                        color: '#000'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
            }
        };

        setPieOptions(pieOptions);
        setLineOptions(lineOptions);
        setBarOptions(barOptions)
    }

    useEffect(() => {
        applyLightTheme();
    }, [piePreescolar]);



    return (
        <div>
            <Menu link='filtro' />

            <div className="row">
                <div className='col-12'>
                    <div className="py-0 ">
                        <div className="font-medium text-4xl text-900 " style={{ textAlign: 'center', paddingBottom: '15px' }}>ESTADÍSTICAS</div>

                        <div className='card col-12' style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', marginBottom: '30px' }}>
                            <div className='grid col-12' style={{ borderRadius: '12px', background: '#FFFFFF' }}>

                                <div id='metaEntregar' className='col-12 lg:col-4 md:col-4 flex lg:justify-content-center md:justify-content-center lg:mb-0 md:mb-0 mb-2'>
                                    <i className="pi pi-car text-2xl md:text-4xl" style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                                    <div>
                                        <span className="text-900 font-medium text-2xl lg:text-3xl md:text-3xl">
                                            {loading ? <Loader rem='2rem' /> : general?.totalEntrega}
                                        </span>
                                        <div className="text-900 font-small mb-1">META A ENTREGAR</div>

                                    </div>
                                </div>

                                <div id='entregados' className='col-12 lg:col-4 md:col-4 flex lg:justify-content-center md:justify-content-center  lg:mb-0 md:mb-0 mb-2'>
                                    <i className="pi pi-shopping-bag text-2xl md:text-4xl" style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                                    <div>
                                        <span className="text-900 font-medium text-3xl">{loading ? <Loader rem='2rem' /> : general?.totalEntregado}</span>
                                        <div className="text-900 font-small mb-1">ENTREGADOS</div>
                                    </div>
                                </div>

                                <div id='porcentajeEntrega' className='col-12 lg:col-4 md:col-4 flex lg:justify-content-center md:justify-content-center  lg:mb-0 md:mb-0 mb-2'>
                                    <i className="pi pi-check-circle text-2xl md:text-4xl" style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                                    <div>
                                        <span className="text-900 font-medium text-3xl">
                                            {loading ? <Loader rem='2rem' /> : general?.porcentaje}%
                                        </span>
                                        <div className="text-900 font-small mb-1">PORCENTAJE DE ENTREGA</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid" style={{ paddingBottom: '20px' }}>
                        <div className="col-12 lg:col-4">
                            <div className="card p-4" style={{ borderRadius: '12px' }}>
                                <div className="flex mb-3" style={{ justifyContent: 'space-between' }}>
                                    <div className="font-medium text-2xl">
                                        <img src='assets/layout/images/iconAlumno.png' alt="logo" style={{ width: '25px', marginRight: '10px', marginTop: '-5px' }} />
                                        <label>Preescolar</label>
                                    </div>
                                    <div className='flex '>
                                        <div className="font-medium text-2xl" style={{ color: 'gray' }}>{porcentajeNivel !== null && porcentajeNivel.pciento_preescolar}% avance</div>
                                    </div>
                                </div>
                                <hr style={{ border: '1px solid #505050' }} />

                                <div className='col-12' style={{ textAlign: 'center', marginBottom: '-165px', marginTop: '115px' }}>
                                    <div className="font-medium text-2xl">{piePreescolar?.total}</div>
                                    <div className="font-medium text-xl">Total alumnos</div>
                                </div>

                                <Chart type="doughnut" data={piePreescolar} options={pieOptions} style={{ textAlign: '-webkit-center' }} />
                            </div>
                        </div>

                        <div className="col-12 lg:col-4">
                            <div className="card p-4" style={{ borderRadius: '12px' }}>
                                <div className="flex mb-3" style={{ justifyContent: 'space-between' }}>
                                    <div className="font-medium text-2xl">
                                        <img src='assets/layout/images/iconAlumno.png' alt="logo" style={{ width: '25px', marginRight: '10px', marginTop: '-5px' }} />
                                        <label>Primaria</label>
                                    </div>
                                    <div className='flex '>
                                        <div className="font-medium text-2xl" style={{ color: 'gray' }}>{porcentajeNivel !== null && porcentajeNivel.pciento_primaria}% avance</div>
                                    </div>
                                </div>
                                <hr style={{ border: '1px solid #505050' }} />

                                <div className='col-12' style={{ textAlign: 'center', marginBottom: '-165px', marginTop: '115px' }}>
                                    <div className="font-medium text-2xl">{piePrimaria?.total}</div>
                                    <div className="font-medium text-xl">Total alumnos</div>
                                </div>

                                <Chart type="doughnut" data={piePrimaria} options={pieOptions} style={{ textAlign: '-webkit-center' }} />
                            </div>
                        </div>

                        <div className="col-12 lg:col-4">
                            <div className="card p-4" style={{ borderRadius: '12px' }}>
                                <div className="flex mb-3" style={{ justifyContent: 'space-between' }}>
                                    <div className="font-medium text-2xl">
                                        <img src='assets/layout/images/iconAlumno.png' alt="logo" style={{ width: '25px', marginRight: '10px', marginTop: '-5px' }} />
                                        <label>Secundaria</label>
                                    </div>
                                    <div className='flex '>
                                        <div className="font-medium text-2xl" style={{ color: 'gray' }}>{porcentajeNivel !== null && porcentajeNivel.pciento_secundaria}% avance</div>
                                    </div>
                                </div>
                                <hr style={{ border: '1px solid #505050' }} />

                                <div className='col-12' style={{ textAlign: 'center', marginBottom: '-165px', marginTop: '115px' }}>
                                    <div className="font-medium text-2xl">{pieSecundaria?.total}</div>
                                    <div className="font-medium text-xl">Total alumnos</div>
                                </div>

                                <Chart type="doughnut" data={pieSecundaria} options={pieOptions} style={{ textAlign: '-webkit-center' }} />
                            </div>
                        </div>



                        {/* {(show ? 
                        <>
                            <div className="col-12 lg:col-6">
                                <div className="card" >
                                    <div className="flex align-items-center justify-content-between mb-3">
                                        <div className="text-900 font-medium text-xl">Días | de entrega | general</div>
                                    </div>
                                    <Chart type="bar" data={barDataGeneral} options={barOptions} style={{ width: '100%' }}/>
                                </div>
                            </div>

                            <div className="col-12 lg:col-6">
                                <div className="card">
                                    <div className="flex align-items-center justify-content-between mb-3">
                                        <div className="text-900 font-medium text-xl">Días | de entrega | por nivel</div>
                                    </div>
                                    <Chart type="bar" data={barData} options={barOptions} style={{ width: '100%' }}/>
                                </div>
                            </div>
                        </>
                        : "")} */}
                    </div>

                    {/* <DashboardCheck /> */}

                    <DashboardTable porcentaje={(e) => { setPorcentajeNivel(e) }} />
                </div>
            </div>
        </div>
    );
}

export default Dashboard;